import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Cars24Protect from "./component";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Cars24Protect);
